import { render, staticRenderFns } from "./AlfMenu.vue?vue&type=template&id=576342f2"
import script from "./AlfMenu.vue?vue&type=script&lang=js"
export * from "./AlfMenu.vue?vue&type=script&lang=js"
import style0 from "./AlfMenu.vue?vue&type=style&index=0&id=576342f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports